import { StateStorage } from 'zustand/middleware'
import { createStore } from '../.'

interface CurrentWalletStore {
  currentWallet: string
  setCurrentWallet: (walletId: string) => void
}

export const createCurrentWalletStore = (storage: StateStorage) =>
  createStore<CurrentWalletStore>(
    storage,
    (set) => ({
      currentWallet: '',
      setCurrentWallet(walletId) {
        set({ currentWallet: walletId })
      },
    }),
    {
      persist: {
        name: 'currentWallet',
        version: 0,
      },
    }
  )
